import React from 'react';

import { FlexRow, TableData, TableDataProps } from '@make-software/cspr-design';
import { Tooltip, BodyText } from '@block-explorer/ui';

/* eslint-disable-next-line */
export interface DetailsNameTableDataProps extends TableDataProps {
  verticalAlign?: 'baseline' | 'center';
  tooltipText?: string;
  icon?: JSX.Element | undefined;
  capitalize?: boolean;
}

export function DetailsNameTableData({
  children,
  tooltipText,
  icon,
  capitalize = true,
  ...props
}: DetailsNameTableDataProps) {
  return (
    <TableData
      {...props}
      style={{ width: 180, verticalAlign: props.verticalAlign }}
    >
      <Tooltip tooltipContent={tooltipText} limitWidth>
        <FlexRow align={'center'} gap={3}>
          <BodyText
            size={3}
            variation="darkGray"
            noWrap
            capitalize={capitalize}
          >
            {children}
          </BodyText>
          {icon}
        </FlexRow>
      </Tooltip>
    </TableData>
  );
}

export default DetailsNameTableData;
